'use strict'

const AnchorLinks = {
  links: $('a[href*="#"]:not([class*="js-scroll-link"]')
}

AnchorLinks.init = function () {
  AnchorLinks.links.on('click', function (e) {
    var href = $(this).attr('href')

    // Return if link is not pointing to current page
    if (href.indexOf('#') > 0) {
      var link = document.createElement('a')
      link.href = href.substr(0, href.indexOf('#'))

      if (link.pathname !== document.location.pathname) {
        return
      }
    }

    // Additional check for existing anchor because chances are
    // that the anchor has been dynamically removed after the
    // event has been attached to a link
    if (href.indexOf('#') < 0) {
      return
    }

    var anchor = $(href.substr(href.indexOf('#')))
    if (!anchor.length) {
      return
    }

    $('html, body').animate({
      scrollTop: anchor.offset().top - 120,
    }, 'slow')
  })
}

export { AnchorLinks }
